(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-minimal"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function collectCartSectionIds() {
      var ids = [];
      var components = document.querySelectorAll('cart-items-component');
      components.forEach(function (item) {
        if (item.dataset && item.dataset.sectionId) {
          ids.push(item.dataset.sectionId);
        }
      });
      return ids;
    }

    function dispatchCartUpdate(card, cart, qty, sections) {
      var event = new CustomEvent('cart:update', {
        bubbles: true,
        cancelable: true,
        detail: {
          resource: cart,
          sourceId: card.dataset.productId || 'np-card',
          data: {
            source: 'np-card',
            itemCount: qty,
            productId: card.dataset.productId,
            variantId: card.querySelector('[data-product-form]').dataset.variantId,
            sections: sections || {}
          }
        }
      });
      document.dispatchEvent(event);
    }

    function openHorizonCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      var legacyDrawer = document.querySelector('cart-drawer, [data-cart-drawer]');
      if (legacyDrawer) {
        if (typeof legacyDrawer.open === 'function') {
          legacyDrawer.open();
          return true;
        }
        legacyDrawer.setAttribute('open', '');
        return true;
      }
      return false;
    }

    function setBtnLoading(btn, loading) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!loading);
      btn.disabled = !!loading;
    }

    function setBtnAdded(btn, label) {
      if (!btn) return;
      var labelEl = btn.querySelector('.np-card__btn-label');
      if (!labelEl) return;
      var originalText = labelEl.textContent;
      labelEl.textContent = label || 'Added ✓';
      btn.classList.add('is-added');
      setTimeout(function () {
        labelEl.textContent = originalText;
        btn.classList.remove('is-added');
      }, 1600);
    }

    function showError(form, message) {
      var err = form.querySelector('[data-error]');
      if (!err) return;
      err.textContent = message;
      err.hidden = false;
      setTimeout(function () { err.hidden = true; }, 4000);
    }

    function getSelectedPlanId(card) {
      if (card.dataset.mode !== 'subscription') return null;
      var select = card.querySelector('[data-freq-select]');
      if (select && select.value) {
        return parseInt(select.value, 10);
      }
      return null;
    }

    function addToCart(form, card) {
      var variantId = form.dataset.variantId;
      var qtyInput = form.querySelector('.np-card__qty-input');
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var sellingPlanId = getSelectedPlanId(card);
      var sectionIds = collectCartSectionIds();

      var payload = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: qty
        }]
      };

      if (sellingPlanId) {
        payload.items[0].selling_plan = sellingPlanId;
      }

      if (sectionIds.length > 0) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function (addResponse) {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            dispatchCartUpdate(card, cart, qty, addResponse.sections);
            return { cart: cart, sections: addResponse.sections };
          });
      });
    }

    function syncSubscribeDisplay(card) {
      var select = card.querySelector('[data-freq-select]');
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      var priceEl = card.querySelector('[data-sub-price-display]');
      var saveBadgePct = card.querySelector('[data-save-pct]');

      if (priceEl && opt.dataset.planPrice) {
        priceEl.textContent = opt.dataset.planPrice;
      }
      if (saveBadgePct && opt.dataset.planSavingsPct) {
        saveBadgePct.textContent = opt.dataset.planSavingsPct;
      }
    }

    function handlePlanSelector(card) {
      var form = card.querySelector('[data-product-form]');
      var planRadios = card.querySelectorAll('.np-card__plan-radio');
      if (!form || planRadios.length === 0) return;

      planRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          if (radio.dataset.planType === 'subscription') {
            card.dataset.mode = 'subscription';
            var planId = getSelectedPlanId(card);
            if (planId) {
              form.dataset.sellingPlanId = String(planId);
            }
          } else {
            card.dataset.mode = 'onetime';
            delete form.dataset.sellingPlanId;
            form.removeAttribute('data-selling-plan-id');
          }
        });
      });
    }

    function handleFreqDropdown(card) {
      var form = card.querySelector('[data-product-form]');
      var select = card.querySelector('[data-freq-select]');
      if (!form || !select) return;

      function ensureSubscriptionMode() {
        if (card.dataset.mode === 'subscription') return;
        var subRadio = card.querySelector('.np-card__plan-radio[data-plan-type="subscription"]');
        if (subRadio) {
          subRadio.checked = true;
          card.dataset.mode = 'subscription';
          var planId = getSelectedPlanId(card);
          if (planId) form.dataset.sellingPlanId = String(planId);
        }
      }

      ['focus', 'mousedown', 'touchstart'].forEach(function (eventName) {
        select.addEventListener(eventName, ensureSubscriptionMode);
      });

      select.addEventListener('change', function () {
        ensureSubscriptionMode();
        var planId = parseInt(select.value, 10);
        if (planId) {
          form.dataset.sellingPlanId = String(planId);
        }
        syncSubscribeDisplay(card);
      });
    }

    function handleQuantity(card) {
      var input = card.querySelector('.np-card__qty-input');
      var decBtn = card.querySelector('[data-qty-action="decrease"]');
      var incBtn = card.querySelector('[data-qty-action="increase"]');
      if (!input || !decBtn || !incBtn) return;

      function clamp(val) {
        var n = parseInt(val, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > 99) n = 99;
        return n;
      }

      function updateState() {
        var val = clamp(input.value);
        input.value = val;
        decBtn.disabled = val <= 1;
        incBtn.disabled = val >= 99;
      }

      decBtn.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) - 1);
        updateState();
      });

      incBtn.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) + 1);
        updateState();
      });

      input.addEventListener('change', updateState);
      input.addEventListener('blur', updateState);

      updateState();
    }

    function handleActions(card) {
      var form = card.querySelector('[data-product-form]');
      if (!form) return;

      var addBtn = form.querySelector('[data-action="add-to-cart"]');
      var buyBtn = form.querySelector('[data-action="buy-now"]');

      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          setBtnLoading(addBtn, true);
          addToCart(form, card)
            .then(function () {
              setBtnLoading(addBtn, false);
              setBtnAdded(addBtn, 'Added ✓');
              openHorizonCartDrawer();
            })
            .catch(function (err) {
              setBtnLoading(addBtn, false);
              showError(form, err.message);
            });
        });
      }

      if (buyBtn) {
        buyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          setBtnLoading(buyBtn, true);
          addToCart(form, card)
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              setBtnLoading(buyBtn, false);
              showError(form, err.message);
            });
        });
      }
    }

    /* ============================================================
       VARIANT SELECTOR
       Reads variant data from a data-variants-json attribute (see
       comment header for why this is no longer an inline <script>
       tag), listens for option changes, finds the matching variant
       by comparing option arrays, then updates all dependent
       displays (prices, freq dropdown, badges).
       ============================================================ */
    function getVariantsData(card) {
      var raw = card.dataset.variantsJson;
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    function findMatchingVariant(variants, selectedOptions) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateCardForVariant(card, variant) {
      if (!variant) return;
      var form = card.querySelector('[data-product-form]');
      if (!form) return;

      // Update variant ID on form and hidden input
      form.dataset.variantId = String(variant.id);
      var hiddenInput = form.querySelector('[data-variant-id-input]');
      if (hiddenInput) hiddenInput.value = String(variant.id);

      // Update on-sale state at card level (controls badge visibility)
      card.dataset.onSale = variant.on_sale ? 'true' : 'false';
      var saleBadge = card.querySelector('[data-sale-badge]');
      if (saleBadge) saleBadge.hidden = !variant.on_sale;

      // Update one-time price display
      var oneTimePriceEl = card.querySelector('[data-onetime-price]');
      if (oneTimePriceEl) {
        oneTimePriceEl.textContent = variant.price_money;
        oneTimePriceEl.classList.toggle('np-card__plan-price-value--sale', !!variant.on_sale);
        oneTimePriceEl.classList.toggle('np-card__price--sale', !!variant.on_sale);
      }

      // Update one-time compare-at price
      var oneTimeCompare = card.querySelector('[data-onetime-compare]');
      if (oneTimeCompare) {
        if (variant.on_sale && variant.compare_at_price_money) {
          oneTimeCompare.textContent = variant.compare_at_price_money;
          oneTimeCompare.hidden = false;
        } else {
          oneTimeCompare.hidden = true;
        }
      }

      // Update subscribe section's compare-at (always shows current one-time price)
      var subCompare = card.querySelector('[data-sub-compare]');
      if (subCompare) {
        subCompare.textContent = variant.price_money;
      }

      // Update freq dropdown options with new per-variant pricing
      var freqSelect = card.querySelector('[data-freq-select]');
      if (freqSelect && variant.allocations) {
        var options = freqSelect.querySelectorAll('option');
        options.forEach(function (opt) {
          var planId = opt.dataset.planId;
          var planName = opt.dataset.planName || '';
          var alloc = variant.allocations[planId];
          if (alloc) {
            opt.dataset.planPrice = alloc.price_money;
            opt.dataset.planSavingsPct = String(alloc.savings_pct);
            opt.textContent = planName + (alloc.savings_pct > 0 ? ' · Save ' + alloc.savings_pct + '%' : '');
            opt.disabled = false;
          } else {
            opt.disabled = true;
          }
        });
        syncSubscribeDisplay(card);
      }

      // Handle availability — toggle button states and labels
      var addBtn = form.querySelector('[data-action="add-to-cart"]');
      var buyBtn = form.querySelector('[data-action="buy-now"]');
      var addLabel = addBtn ? addBtn.querySelector('.np-card__btn-label') : null;
      var buyLabel = buyBtn ? buyBtn.querySelector('.np-card__btn-label') : null;

      if (!variant.available) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold out';
        if (buyLabel) buyLabel.textContent = 'Sold out';
      } else {
        if (addBtn) addBtn.disabled = false;
        if (buyBtn) buyBtn.disabled = false;
        if (addLabel && addLabel.textContent === 'Sold out') addLabel.textContent = 'Add to cart';
        if (buyLabel && buyLabel.textContent === 'Sold out') buyLabel.textContent = 'Buy now';
      }
    }

    function handleVariantSelectors(card) {
      var selectors = card.querySelectorAll('.np-card__variant-select');
      if (selectors.length === 0) return;

      var variants = getVariantsData(card);
      if (!variants || variants.length === 0) return;

      function syncFromCurrentSelections() {
        var selectedOptions = [];
        selectors.forEach(function (s) {
          selectedOptions.push(s.value);
        });
        var matching = findMatchingVariant(variants, selectedOptions);
        if (matching) {
          updateCardForVariant(card, matching);
        } else {
          // No exact match — disable buy buttons and show error
          var form = card.querySelector('[data-product-form]');
          var addBtn = form ? form.querySelector('[data-action="add-to-cart"]') : null;
          var buyBtn = form ? form.querySelector('[data-action="buy-now"]') : null;
          if (addBtn) addBtn.disabled = true;
          if (buyBtn) buyBtn.disabled = true;
          if (form) showError(form, 'That combination is not available.');
        }
      }

      selectors.forEach(function (select) {
        select.addEventListener('change', syncFromCurrentSelections);
      });
    }

    function init() {
      var cards = document.querySelectorAll('.np-card');
      cards.forEach(function (card) {
        if (card.dataset.npInit === 'true') return;
        card.dataset.npInit = 'true';
        handleVariantSelectors(card);
        handlePlanSelector(card);
        handleFreqDropdown(card);
        handleQuantity(card);
        handleActions(card);
        syncSubscribeDisplay(card);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('cart:update', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
